const timesheetCommonServicesName = "/Common";

export function timesheetCommonServices(http) {
    return {
        getAllCostCenterProjects: () => {
            return http.get(timesheetCommonServicesName + "/GetAllCotCenterProject");
        },
        getDisciplineListAsync: async () => {
            return await http.get(timesheetCommonServicesName + "/GetDisciplineListAsync");
        },
        getSpecificCostCenter: async (costCenterCode) => {
            let param = {
                Code: costCenterCode
            }
            return await http.post(timesheetCommonServicesName + "/GetSpecificCostCenter", param);
        },
        getActivitiesList: async (costCenterCode, projectCode) => {
            let param = {
                DisciplineCode: costCenterCode,
                ProjectCode: projectCode
            }
            return await http.post(timesheetCommonServicesName + "/GetActivitiesList", param);
        },
        getWorkingTypeList: () => {
            return http.get(timesheetCommonServicesName + "/GetWorkingTypeList");
        },
        getDuplicationsList: () => {
            return http.get(timesheetCommonServicesName + "/GetDuplicationsList");
        }
    }
    
}